/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var Session = require('psa-core/Session');

var modelGet = require('common/util/modelGet');
var HeaderBarView = require('common/views/HeaderBarView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var FileUploadTableView = require('common/views/FileUploadTableView');
var ContentServerLinkView = require('common/views/ContentServerLinkView');

var SubmitReviewFinancialStatementTask = require('../../services/SubmitReviewFinancialStatementTask');

var tmplSecReviewFinancialStatementTaskView = require('./SecReviewFinancialStatementTaskView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecReviewFinancialStatementTaskView,

  className: 'sec-review-financial-statement-task-view container-fluid',

  ui: {
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    csLinkContainer: '.cs-link-container',
    financialStatementForm: '.financial-statement-form',
    extFileUploadTableContainer: '.ext-file-upload-table-container',
    intFileUploadTableContainer: '.int-file-upload-table-container',
    intComments: '[name="internalComments"]',
    submit: '.submit',
    missingFile: '.missing-file'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    extFileUploadTableContainer: '@ui.extFileUploadTableContainer',
    intFileUploadTableContainer: '@ui.intFileUploadTableContainer',
    csLinkContainer: '@ui.csLinkContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  behaviors: {
    TaskBehavior: {}
  },

  onBeforeShow: function() {
    var financialStatement = this.model.get('financialStatement') || {};

    this.showChildView(
      'csLinkContainer',
      new ContentServerLinkView({
        model: new Backbone.Model({
          buttonText: 'Open Financial Statement Folder',
          contentServerId: financialStatement.csFolderId
        })
      })
    );

    var headerBarColumns = [
      {
        name: 'applicantLegalName',
        label: 'Applicant Legal Name',
        minWidth: '160px',
        maxWidth: '300px'
      },
      {
        name: 'CRDNumber',
        label: 'CRD Number',
        minWidth: '160px',
        maxWidth: '300px'
      },
      {
        name: 'nonFINRANumber',
        label: 'Non FINRA Number',
        minWidth: '160px',
        maxWidth: '300px'
      }
    ];

    this.showChildView(
      'headerBar',
      new HeaderBarView({
        columns: new Backbone.Collection(headerBarColumns),
        model: new Backbone.Model(this.model.get('organization'))
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#sec/dashboard',
            text: 'Home'
          },
          {
            text: 'Submit Financials'
          }
        ]
      })
    );

    var internalDocuments = _.each(modelGet(this.model, 'financialStatement.internalDocuments', []), function(doc) {
      doc.documentType = doc.documentTypeId;
    });

    this.intFileUploadTableView = new FileUploadTableView({
      documentTypes: this.model.get('documentTypes'),
      collection: new Backbone.Collection(internalDocuments),
      emptyText: 'No Documents',
      isReadOnly: false
    });

    this.showChildView('intFileUploadTableContainer', this.intFileUploadTableView);

    this.extFileUploadTableView = new FileUploadTableView({
      collection: new Backbone.Collection(modelGet(this.model, 'financialStatement.externalDocuments', [])),
      emptyText: 'No Documents',
      isReadOnly: true
    });

    this.showChildView('extFileUploadTableContainer', this.extFileUploadTableView);

    var internalComments = modelGet(this.model, 'financialStatement.internalComments');
    if (internalComments) {
      this.ui.intComments.val('\n\n' + internalComments);
    }
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      SubmitReviewFinancialStatementTask(self.getFormData())
        .done(function() {
          Radio.channel('navigate').trigger('show:int:sc:dashboard');
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  validateAttachmentComments: function() {
    var defer = $.Deferred();
    var hasOneSuccessfulFileOrComment = true;
    var hasComments = !!this.ui.intComments.val();
    var uploads = this.intFileUploadTableView.getFormData();

    this.ui.missingFile.hide();
    hasOneSuccessfulFileOrComment = uploads.length || hasComments;

    if (!hasOneSuccessfulFileOrComment) {
      this.ui.missingFile.show();
      defer.reject();
    } else {
      defer.resolve();
    }

    return defer.promise();
  },

  validate: function() {
    return $.when.apply($, [
      this.ui.financialStatementForm.parsley().whenValidate(),
      this.intFileUploadTableView.validate({ type: 'submit' }, 0),
      this.validateAttachmentComments()
    ]);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    _.extend(formData, {
      taskId: this.model.get('taskId'),
      financialStatementId: this.model.get('financialStatementId')
    });
    formData.documents = this.intFileUploadTableView.getFormData();

    var timestamp = moment().format('MM/DD/YYYY h:mm A');
    var userName = Session.user.description;
    formData.internalComments = '[' + userName + ' - ' + timestamp + '] \n' + formData.internalComments;

    return formData;
  }
});
